<ng-container *ngIf="send">
  <div [innerHTML]="translationService.getTranslation('contact_send')"></div>
</ng-container>
<ng-container *ngIf="!send">
  <div class="row">
    <div class="col-12">
      <h3 *appApplyIfNotEmpty="translationService.getTranslation('contact_intro')"
          [innerHTML]="translationService.getTranslation('contact_intro')"></h3>
    </div>
    <div class="col-12">
      <h4 [innerHTML]="translationService.getTranslation('contact_description')"></h4>
    </div>
  </div>

  <app-general-errors [errors]="errorsArr"></app-general-errors>

  <mat-card class="mt-3">
    <mat-card-content>
  <form [formGroup]="contactForm">
    <div class="row">
      <mat-form-field class="col-12">
        <mat-label [innerHTML]="translationService.getTranslation('contact_type')"></mat-label>
        <mat-select formControlName="reason"required aria-required="true" data-cy="select-contact-type">
          <mat-option *ngFor="let contactType of contactTypes"
                      [value]="contactType.key" data-cy="option-contact-type">{{contactType.description}}</mat-option>
        </mat-select>
        <mat-error
          *ngIf="contactForm.get('reason').hasError('message')">{{contactForm.get('reason').getError('message')}}</mat-error>
      </mat-form-field>
      <mat-form-field class="col-12">
        <mat-label>{{translationService.getTranslation('contact_message')}}</mat-label>
        <textarea maxLength="65535" matInput cdkAutosizeMinRows="5" cdkTextareaAutosize formControlName="memo" required
                  #memo data-cy="input-contact-message"></textarea>
        <mat-hint *ngIf="memo === document?.activeElement && memo.value.length >= 1" align="end">{{memo.value.length}} / {{memo.maxLength}}</mat-hint>
        <mat-error
          *ngIf="contactForm.get('memo').hasError('message')">{{contactForm.get('memo').getError('message')}}</mat-error>
      </mat-form-field>

      <div *ngIf="isSaving" style="text-align: center;">
        <app-loading-spinner></app-loading-spinner>
      </div>

      <div class="col-12">
        <button [hidden]="isSaving" mat-raised-button color="primary" data-cy="btn-send"
                [disabled]="contactForm.invalid ||
                              !(
                                !unauthorized ||
                                (userBackendId !== undefined && userBackendId > 0) ||
                                (isValidEmail(this.emailAddress) === 'valid' && addressForm.valid)
                              )"
                (click)="onSendContact()">
          {{ translationService.getTranslation('button_send') }}
        </button>
      </div>
    </div>
  </form>
    </mat-card-content>
  </mat-card>
</ng-container>
